import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import NXLogo from "../../assets/images/NXLogo.png";
import Playicon from "../../assets/images/icon/playicon.png";
import Appleicon from "../../assets/images/icon/Appleicon.png";
import { Container } from '@mui/material';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useTheme } from "../../context/ThemeContext";
import { IoMoon, IoSunnyOutline } from 'react-icons/io5';


const navItems = [
    { name: 'App Store', icon: Appleicon, href: "https://apps.apple.com/us/app/nvxo-wallet-crypto-btc/id6741467282" },
    { name: 'Play Store', icon: Playicon, href: "https://play.google.com/store/apps/details?id=com.nvwallet.wallet" },
];

export default function DrawerAppBar() {
    const { theme, toggleTheme } = useTheme();

    const notify = () => toast("Coming soon");


    return (
        <Box className="top-new-navbar-css" sx={{ display: 'flex' }}>
            <CssBaseline />
            <AppBar component="nav" className={`navbar`} position='relative'>
                <Container maxWidth="xl">
                    <Toolbar>
                        <Typography
                            variant="h6"
                            component="div"
                            sx={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}
                        >
                            <Link to="/" className='navbar-brand'>
                                <LazyLoadImage
                                    alt="Logo"
                                    src={NXLogo}
                                />
                            </Link>
                        </Typography>
                        <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                            {navItems.map((item) => (
                                item.href ? (
                                    <Link to={item.href} target='_blank' rel="noopener noreferrer" key={item.name}>
                                        <Button className='nav-items nav-items-top-1'>
                                            <LazyLoadImage
                                                alt="Logo"
                                                src={item.icon}
                                                className={`nav-items-top-1-1 ${item.name === "App Store" ? "apple-icon" : ""}`}
                                            />
                                            <span className='nv-txt'>{item.name}</span>
                                        </Button>
                                    </Link>
                                ) : (
                                    <Button
                                        className='nav-items nav-items-top-1'
                                        onClick={notify}
                                        key={item.name}
                                    >
                                        <LazyLoadImage
                                            alt="Logo"
                                            src={item.icon}
                                            className={`nav-items-top-1-1 ${item.name === "App Store" ? "apple-icon" : ""}`}
                                        />
                                        <span className='nv-txt'>{item.name}</span>
                                    </Button>
                                )
                            ))}
                        </Box>
                        <button onClick={toggleTheme} className="theme-btn">
                            {theme === "light" ? <IoMoon /> : <IoSunnyOutline />}
                        </button>
                    </Toolbar>
                </Container>
            </AppBar>

        </Box >
    );
}
